import { useEffect } from "react";
import { useRole } from "@/store/role";
import {
  getAccessToken,
  getAccessTokenExpiryMs,
  isAccessTokenExpired,
} from "@/lib/auth";
import { expireSession } from "@/lib/sessionExpiry";

const MAX_TIMEOUT_MS = 2_147_000_000;

/**
 * Logs the user out when the JWT `exp` is reached, even if no API call is in flight.
 */
export default function SessionWatch() {
  const { currentUser } = useRole();

  useEffect(() => {
    function check() {
      const token = getAccessToken();
      if (token && isAccessTokenExpired(token)) expireSession();
    }

    check();

    const token = getAccessToken();
    if (!token || isAccessTokenExpired(token)) return undefined;

    const expMs = getAccessTokenExpiryMs(token);
    if (expMs == null) return undefined;

    const delay = Math.min(Math.max(expMs - Date.now() - 1500, 0), MAX_TIMEOUT_MS);
    const id = window.setTimeout(() => expireSession(), delay);
    const onResume = () => check();
    document.addEventListener("visibilitychange", onResume);
    window.addEventListener("focus", onResume);

    return () => {
      window.clearTimeout(id);
      document.removeEventListener("visibilitychange", onResume);
      window.removeEventListener("focus", onResume);
    };
  }, [currentUser?.qid]);

  return null;
}
